import "./Description.css";

const Description = () => {
  return (
    <div className="description-container">
      <div className="description-content">
        <p className="description-intro">
          Explore additional datasets and documents that have been uploaded to
          TDIS.
        </p>
        <div className="description-section">
          <h3 className="section-title">Quick Actions</h3>
          <p className="section-text">
            Click the download icon next to a file to download it instantly. If
            the file is larger than 10G, instructions are displayed to download
            and use AzCopy to facilitate quicker download times. For folders,
            simply click on the folder to view its contents.
          </p>
        </div>
        <div className="description-section">
          <h3 className="section-title">Sorting and Filtering</h3>
          <p className="section-text">
            The results can be sorted by Name or Kind(Folder/File). By default,
            the results are sorted to display the folders at the top followed by
            the files. Additionally, the filter option in the Kind column can be
            used to display only files, folders, or both.
          </p>
        </div>
        <div className="description-section">
          <h3 className="section-title">Breadcrumb Navigation</h3>
          <p className="section-text">
            Breadcrumbs are provided at the bottom of the screen to view the
            current location and to quickly navigate back to any previous
            folder. Breadcrumbs update dynamically as you explore, keeping your
            navigation simple and efficient.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Description;
